// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "../application"

//import AttemptLayoutController from "./attempts/layout"
import AttemptsCheckboxController from "./attempts/checkbox"
import NotificationsController from "./notifications/notifications_controller"
import NotificationToastController from "./notifications/notification_toast"
import FeedbackController from "./attempts/feedback"
import ScoreModalController from "./attempts/score_modal"
import ScaleController from "./attempts/scale"
import ScrollableController from "./attempts/scrollable"
import InfoToastController from "./info_toast"


//application.register("attempt-layout", AttemptLayoutController)
application.register("checkbox", AttemptsCheckboxController)
application.register("notifications", NotificationsController)
application.register("notification_toast", NotificationToastController)
application.register("feedback", FeedbackController)
application.register("score_modal", ScoreModalController)
application.register("scale", ScaleController)
application.register("scrollable", ScrollableController)
application.register("info_toast", InfoToastController)
